import { window } from "../global_constants";

/*
 Redirect URI must be registered in your auth0 client settings, or it will not work:
 Add new Allowed Callback URLs at: https://manage.auth0.com/#/clients/<your_client_id>/settings
*/

const CALLBACK_URI = `${window.URLS.CLIENT_BASE_URL + window.ROUTING_BASENAME}callback`;
const CONFIG = { ...window.AUTH_CONFIG, redirectUri: CALLBACK_URI };
const LOCAL_STORAGE_PREFIX = "__CSTOOL__";

/*
 Logout Return To URI must be registered in auth0, or it will not work:
 Add new Allowed Logout URLs at: https://manage.auth0.com/#/tenant/advanced
 */
const TOKEN_MINIMUM_TTL = 60;
const { TOKEN_RENEW_CALLBACK_URI } = window.URLS.AUTH;

export {
    CONFIG,
    LOCAL_STORAGE_PREFIX,
    TOKEN_MINIMUM_TTL,
    TOKEN_RENEW_CALLBACK_URI,
};
